import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-pen-2-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4714 1.5288C13.4747 0.532069 11.8587 0.532067 10.862 1.5288L10.0876 2.30315C9.82359 2.56716 9.69158 2.69916 9.64212 2.85138C9.59862 2.98528 9.59862 3.12951 9.64212 3.2634C9.69158 3.41562 9.82359 3.54763 10.0876 3.81164L12.1886 5.91262C12.4526 6.17663 12.5846 6.30864 12.7368 6.3581C12.8707 6.4016 13.0149 6.4016 13.1488 6.3581C13.3011 6.30864 13.4331 6.17663 13.6971 5.91262L14.4714 5.13827C15.4682 4.14155 15.4682 2.52553 14.4714 1.5288Z"
        [attr.fill]="color"
      />
      <path
        d="M11.2458 8.36392C11.5098 8.09991 11.6418 7.96791 11.6912 7.81569C11.7348 7.68179 11.7348 7.53756 11.6912 7.40367C11.6418 7.25145 11.5098 7.11944 11.2458 6.85543L9.14479 4.75445C8.88078 4.49044 8.74877 4.35843 8.59655 4.30897C8.46266 4.26547 8.31843 4.26547 8.18453 4.30897C8.03231 4.35843 7.90031 4.49043 7.6363 4.75444L2.02449 10.3662C1.86096 10.5295 1.71671 10.6735 1.60388 10.8446C1.50467 10.995 1.42626 11.1582 1.37075 11.3296C1.30763 11.5246 1.28528 11.7273 1.25994 11.9569L1.00408 14.2599C0.981717 14.4612 1.05206 14.6617 1.19527 14.8049C1.33847 14.9481 1.53901 15.0185 1.74029 14.9961L4.04329 14.7403C4.27297 14.7149 4.47556 14.6926 4.67056 14.6295C4.84201 14.574 5.00516 14.4955 5.1556 14.3963C5.32672 14.2835 5.47074 14.1392 5.634 13.9757L11.2458 8.36392Z"
        [attr.fill]="color"
      />
    </svg>
  `,
})
export class Pen2Icon extends BaseIconComponent {}
